import { useState } from 'react';
import { exportMarkdownAsPdf, exportMarkdownAsWord } from '../lib/export';

/**
 * Affiche une réponse IA (texte/markdown) avec des boutons d'export
 * dès qu'elle dépasse ~200 caractères.
 */
export default function AiAnswer({
  title,
  text,
  costUsd,
  attached,
}: {
  title: string;
  text: string;
  costUsd?: number;
  attached?: string | null;
}) {
  const [busy, setBusy] = useState<null | 'pdf' | 'docx'>(null);
  const longEnough = text.trim().length > 200;

  async function onExport(kind: 'pdf' | 'docx') {
    setBusy(kind);
    try {
      if (kind === 'pdf') await exportMarkdownAsPdf(title, text);
      else await exportMarkdownAsWord(title, text);
    } catch (e) {
      alert(e instanceof Error ? e.message : "Export impossible");
    } finally {
      setBusy(null);
    }
  }

  return (
    <div
      style={{
        padding: 12,
        background: 'var(--c-nav)',
        borderRadius: 8,
        whiteSpace: 'pre-wrap',
        fontSize: 13.5,
        maxHeight: 500,
        overflow: 'auto',
      }}
    >
      {attached && (
        <div className="card-meta" style={{ marginBottom: 6, fontSize: 11 }}>
          📎 {attached}
        </div>
      )}
      <div>{text}</div>
      {longEnough && (
        <div
          style={{
            display: 'flex',
            gap: 8,
            marginTop: 12,
            borderTop: '1px solid var(--c-border)',
            paddingTop: 10,
          }}
        >
          <button
            className="btn btn-ghost"
            style={{ padding: '6px 10px', fontSize: 12 }}
            disabled={busy !== null}
            onClick={() => onExport('pdf')}
          >
            {busy === 'pdf' ? '…' : '📄 Télécharger .pdf'}
          </button>
          <button
            className="btn btn-ghost"
            style={{ padding: '6px 10px', fontSize: 12 }}
            disabled={busy !== null}
            onClick={() => onExport('docx')}
          >
            {busy === 'docx' ? '…' : '📝 Télécharger .doc'}
          </button>
        </div>
      )}
      {typeof costUsd === 'number' && (
        <div className="card-meta" style={{ marginTop: 8, fontSize: 11 }}>
          ≈ {costUsd.toFixed(4)} USD
        </div>
      )}
    </div>
  );
}
